import { createModel } from "@rematch/core";
import { CustomerDensityState, CustomerGroupFilterState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, signoutIfUnauthorized } from "./utilities";

const initialState: CustomerDensityState = {
  features: [],
  loading: true,
  type: "FeatureCollection",
};

export const customerDensity = createModel<RootModel>()({
  state: initialState as CustomerDensityState,
  reducers: {
    fetchPending(state) {
      return { ...state, loading: true };
    },
    fetchSuccess(state, payload: any) {
      return {
        ...state,
        ...payload,
        loading: false,
      };
    },
    fetchFail(state) {
      return { ...state, loading: false };
    },
  },
  effects: (dispatch) => ({
    async fetchCustomerDensity(
      customerGroupFilter: CustomerGroupFilterState,
      rootState
    ) {
      dispatch.customerDensity.fetchPending();

      const token = checkToken(rootState, () =>
        dispatch.customerDensity.fetchFail()
      );
      if (!token) return;

      try {
        const customerDensityResult = await api.fetchCustomerDensity(
          token,
          customerGroupFilter
        );
        dispatch.customerDensity.fetchSuccess(customerDensityResult);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.customerDensity.fetchFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/customerDensity.ts